interface AdicionaisMenuProps {
  onClose: () => void;
}

const adicionais = [
  {
    icon: 'ri-goblet-line',
    title: 'Copos Personalizados',
    description: 'Copos exclusivos com a identidade do seu evento, tornando cada drink ainda mais especial e memorável.',
    image: 'https://public.readdy.ai/ai/img_res/30a84161cb1bf92f7a538ff8c14b2704.jpg',
  },
  {
    icon: 'ri-leaf-line',
    title: 'Decoração de Bar',
    description: 'Elementos decorativos sofisticados para o bar: flores, velas, elementos naturais e peças exclusivas que harmonizam com o tema do evento.',
    image: 'https://readdy.ai/api/search-image?query=luxurious%20bar%20decoration%20setup%20with%20flowers%20candles%20botanical%20elements%20gold%20accents%20dark%20elegant%20background%2C%20premium%20event%20bar%20styling%2C%20sophisticated%20party%20decor%2C%20studio%20photography&width=400&height=260&seq=adicional2&orientation=landscape',
  },
  {
    icon: 'ri-camera-line',
    title: 'Papel Arroz Personalizado',
    description: 'Papéis de arroz com arte exclusiva para decorar os drinks, criando uma apresentação única e instagramável para o seu evento.',
    image: 'https://readdy.ai/api/search-image?query=cocktail%20drink%20with%20custom%20rice%20paper%20decoration%20on%20top%2C%20elegant%20presentation%2C%20golden%20details%2C%20dark%20moody%20background%2C%20premium%20cocktail%20garnish%2C%20artistic%20drink%20photography&width=400&height=260&seq=adicional3&orientation=landscape',
  },
  {
    icon: 'ri-fire-line',
    title: 'Técnicas Especiais',
    description: 'Defumação, espumas artesanais, clarificação e outras técnicas exclusivas que transformam cada drink em uma experiência sensorial completa.',
    image: 'https://readdy.ai/api/search-image?query=cocktail%20smoking%20technique%20with%20smoke%20cloche%20glass%20dome%2C%20dramatic%20dark%20background%2C%20premium%20mixology%20technique%2C%20golden%20amber%20drink%2C%20luxury%20bar%20experience%2C%20moody%20atmospheric%20photography&width=400&height=260&seq=adicional4&orientation=landscape',
  },
  {
    icon: 'ri-gift-line',
    title: 'Kits de Lembrança',
    description: 'Kits personalizados para os convidados levarem para casa: miniaturas de drinks, receitas exclusivas e brindes temáticos do evento.',
    image: 'https://readdy.ai/api/search-image?query=elegant%20gift%20kit%20box%20with%20miniature%20cocktail%20bottles%20personalized%20labels%20ribbon%20bow%2C%20luxury%20event%20favor%20packaging%2C%20dark%20background%20golden%20accents%2C%20premium%20party%20gift%2C%20studio%20photography&width=400&height=260&seq=adicional5&orientation=landscape',
  },
  {
    icon: 'ri-music-line',
    title: 'Cardápio Impresso Premium',
    description: 'Cardápios físicos impressos em papel especial com acabamento premium, apresentando os drinks do evento com design exclusivo.',
    image: 'https://readdy.ai/api/search-image?query=premium%20printed%20cocktail%20menu%20card%20with%20gold%20foil%20typography%20on%20dark%20paper%2C%20luxury%20event%20menu%20design%2C%20elegant%20typography%2C%20dark%20background%2C%20sophisticated%20stationery%2C%20studio%20photography&width=400&height=260&seq=adicional6&orientation=landscape',
  },
];

export default function AdicionaisMenu({ onClose }: AdicionaisMenuProps) {
  return (
    <section
      className="py-12 sm:py-16 lg:py-20"
      style={{ background: 'linear-gradient(135deg, #0D0A06 0%, #1A1200 50%, #0D0A06 100%)' }}
    >
      <div className="max-w-4xl mx-auto px-5 sm:px-10">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <p className="text-[#D4AF37] text-xs uppercase tracking-[0.4em] mb-4 font-light">
            Toque de exclusividade
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl font-light text-white mb-6">
            Adicionais Barem
          </h2>
          <div className="w-16 h-px bg-[#D4AF37] mx-auto mb-6"></div>
          <p className="text-[#AAAAAA] text-sm font-light tracking-wide max-w-xl mx-auto leading-relaxed">
            A Barem entrega vários adicionais para o seu evento ser único. Cada detalhe pensado para surpreender e encantar seus convidados.
          </p>
        </div>

        {/* Grid de Adicionais */}
        <div className="space-y-8">
          {adicionais.map((item, index) => (
            <div
              key={index}
              className="border border-[#2A2000] hover:border-[#D4AF37] transition-all duration-500 overflow-hidden group"
              style={{ background: 'rgba(212,175,55,0.02)' }}
            >
              {/* Image */}
              <div className="w-full h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              {/* Content */}
              <div className="p-6 sm:p-8 border-t border-[#2A2000] group-hover:border-[#D4AF37] transition-colors duration-500">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center border border-[#2A2000] group-hover:border-[#D4AF37] transition-colors duration-300 shrink-0">
                    <i className={`${item.icon} text-[#D4AF37] text-lg`}></i>
                  </div>
                  <div>
                    <h3 className="text-white text-sm uppercase tracking-widest font-medium mb-2">
                      {item.title}
                    </h3>
                    <div className="w-8 h-px bg-[#D4AF37] mb-3"></div>
                    <p className="text-[#AAAAAA] text-sm font-light leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Nota */}
        <div className="mt-10 text-center">
          <div className="inline-block border border-[#D4AF37]/40 px-8 py-5">
            <p className="text-[#CCCCCC] text-sm font-light leading-relaxed tracking-wide">
              Consulte disponibilidade e condições exclusivas para cada adicional.
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-8 text-center">
          <a
            href="https://wa.me/5562985101348?text=Ol%C3%A1%2C%20gostaria%20de%20solicitar%20uma%20proposta%20para%20os%20Adicionais%20Barem!"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 border border-[#D4AF37] text-[#D4AF37] text-xs uppercase tracking-[0.3em] font-light px-10 py-4 hover:bg-[#D4AF37] hover:text-black transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-sm"></i>
            Solicitar Proposta
          </a>
        </div>
      </div>
    </section>
  );
}
